import { render, staticRenderFns } from "./CbsRefSelParent.vue?vue&type=template&id=4679b8ea&scoped=true"
import script from "./CbsRefSelParent.vue?vue&type=script&lang=js"
export * from "./CbsRefSelParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4679b8ea",
  null
  
)

export default component.exports